import { createPageTracker } from './page-view'

/** The HTML snippet owns GTM loading. Runtime code only queues resolved SPA page views. */
export function createGoogleTagManager(containerId: string, measurementId: string, debug = false) {
  if (!containerId || !measurementId) return
  if (typeof window === 'undefined' || typeof document === 'undefined') return

  window.dataLayer ??= []
  const settings = {
    ga4_measurement_id: measurementId,
    // Undefined omits the parameter in GTM; debug_mode=false does not reliably disable debug traffic.
    ga4_debug_mode: debug ? true : undefined,
  }

  return createPageTracker((page) => {
    // Atomic event + fields ensures GTM resolves the values for this exact navigation.
    window.dataLayer?.push({ event: 'app_page_view', ...page, ...settings })
  })
}
